import { TableHeadClassKey } from '@material-ui/core';
import { CSSProperties } from '@material-ui/core/styles/withStyles';

export const MuiTableHead: Record<TableHeadClassKey, CSSProperties> = {
  root: {},
};
